export default __webpack_public_path__ + "static/media/image1tum.63d31e08.jpg";